<template>
  <v-data-table
    :headers="headers"
    :no-data-text="noDataText"
    :items="items"
    :loading="loading"
    :items-per-page="itemsPerPage"
    :hide-default-footer="hideDefaultFooter"
    :footer-props="{
      'items-per-page-text': 'Itens por página',
      'items-per-page-all-text': 'Todos',
      'disable-items-per-page': true
    }"
  >
    <template
      v-for="header in headers"
      #[`header.${header.key}`]="{ column }"
    >
      <slot
        :name="`header.${header.key}`"
        :column="column"
      >
        <table-header :header="header" />
      </slot>
    </template>

    <template
      v-for="header in headers"
      #[`item.${header.key}`]="{ item }"
    >
      <slot
        :name="`item.${header.key}`"
        :item="item"
      >
        <table-cell
          :header="header"
          :item="item"
        />
      </slot>
    </template>
  </v-data-table>
</template>

<script>
import TableHeader from './TableHeader.vue'
import TableCell from './TableCell.vue'

export default {
  components: {
    TableHeader,
    TableCell,
  },

  props: {
    disabled: Boolean,
    loading: Boolean,
    hideDefaultFooter: Boolean,
    noDataText: {
      type: String,
      default: () => 'Nenhum item disponível',
    },
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    itemsPerPage: {
      type: Number,
      required: true,
    },
  },

  emits: ['update:page'],
}
</script>
